<!-- 商户开户卡片 -->
<template>
  <div v-if="data.payChannel != 'huifu'" class="padding margin-bottom" style="border: 1px solid #DCDFE6">
    <!-- 商户名称 -->
    <div class="flex">
      <div class="flex-grow">{{ data.payChannel  | PayChannelMerchantFormat}}</div>
      <el-tag size="small" :type="tagType(data.applicationStatus)">{{ data.applicationStatus | ApplicationStatusFormat }}</el-tag>
    </div>
    <div class="margin-top">商户编码：{{ data.merchantNo || '-' }}</div>
     <div class="margin-top" v-if="data.payChannel == 'llpay'">
      <span>是否开通免密提现：</span>
      <el-tag v-if="data.papAgreeStatus == '0'" size="mini" type="info"> 未开通</el-tag>
      <el-tag v-if="data.papAgreeStatus == '1'" size="mini" type="success"> 已开通</el-tag>
      <el-tag v-if="data.papAgreeStatus == '2'" size="mini" type="info"> 签署失败</el-tag>
    </div>
    <!-- 描述 -->
    <div class="margin-top" v-if="data.auditOpinion && data.applicationStatus != 'WAIT' && data.applicationStatus != 'SUCCESS'">{{ data.auditOpinion }}</div>
    <div class="margin-top" v-if="data.applicationStatus == 'AGREEMENT_SIGNING' && data.agreementSignurl">
      <span>您有协议需要签署：</span>
      <el-button type="text" @click="toNewPage(data.agreementSignurl)">立即签署</el-button>
      <el-button class="margin-left-sm" type="text">复制链接</el-button>
    </div>
    <div class="margin-top" v-if="(data.applicationStatus == 'ACTIVATE_PENDING_NEW' || data.applicationStatus == 'WAIT_ACTIVATE' || data.applicationStatus == 'URL_CHECK') && data.agreementSignurl">
      <span>您有开户意愿需要签署：</span>
      <el-button type="text" @click="toNewPage(data.agreementSignurl)">立即签署</el-button>
      <el-button class="margin-left-sm" type="text">复制链接</el-button>
    </div>
    <!-- 按钮组 当店铺审核状态为待提交和审核拒绝时，不显示操作按钮 -->
    <div class="margin-top" v-if="shop.auditStatus != 0 && shop.auditStatus !=3">
      <!-- <el-button v-if="data.applicationStatus == 'WAIT'" @click="openApplay" type="danger" size="small">开户申请</el-button> -->
      <el-button v-if=" data.payChannel =='llpay' && ( data.applicationStatus == 'ACTIVATE_PENDING_NEW' || data.applicationStatus == 'WAIT_ACTIVATE')" @click="llpayActivate" type="primary" size="small">开户激活</el-button>
      <el-button v-if=" data.payChannel =='llpay' && data.applicationStatus == 'SUCCESS'  && data.papAgreeStatus != '1'" @click="openAgreeHandle" type="primary" size="small">开通免密提现</el-button>
      <!-- <el-button v-if="data.payChannel == 'huifu' && data.applicationStatus == 'CHECK_PENDING'" type="primary  " size="small" @click="registSucccess">入网完成</el-button> -->
    </div>
    <LLpayMechantActity ref="LLpayMechantActity" @close="refshMerchant"></LLpayMechantActity>
  </div>
</template>

<script>
import LLpayMechantActity from './LLpayMechantActity.vue'

import { LlpayOpenMerchant,OpenMerchantSucccess,HuifuRegistMerchant,PapAgreeApply } from '@/api'
  export default {
    name: "MerchantOpenCardForShop",
    components:{LLpayMechantActity},
    props: {
      data: {
				type: Object,
				default: ()=>{return {}}
			},
      shop: {
				type: Object,
				default: ()=>{return {}}
			},
    },
    data() {
      return {
        test:undefined
      }
    },
    methods: {
      // 开通免密提现
      openAgreeHandle(){
        this.$confirm('是否继续开通免密提现功能?继续开通将调整协议签署界面。', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          PapAgreeApply({id:this.data.id}).then(res=>{
            if(res){
              // 打开新的页面进行签署
              window.open(res,"_blank")
            }
          })
        })

      },
      tagType(v){
        if(v == 'SUCCESS'){
          return 'success'
        } else if(v == 'WAIT'){
          return 'info'
        } else if (v == 'CHECK_PENDING'){
          return ''
        } else {
          return 'danger'
        }
      },
      refshMerchant(){
        // 刷新商户信息
        this.$emit("refshMerchant")
      },
      openApplay(){
        if(this.data.payChannel == 'llpay' ){
          this.openLlpay()
        } else if(this.data.payChannel == 'huifu'){
          console.log("汇付")
          this.huifuOpen()
        }
      },
      huifuOpen(){
        this.$confirm('是否确认提交给汇付支付进行开户？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          HuifuRegistMerchant({id:this.shop.id}).then(res=>{
            console.log(res)
            // 刷新商户信息
            this.refshMerchant()
          })
        })
      },
      openLlpay(){
        this.$confirm('是否确认提交给连连支付进行开户？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          LlpayOpenMerchant({id:this.shop.id}).then(res=>{
            console.log(res)
            // 刷新商户信息
            this.refshMerchant()
          })
        })
      },
      llpayActivate(){
        // 连连激活
        const d = this.$refs.LLpayMechantActity
        d.open(this.shop)
      },
      toNewPage(url){
        window.open(url, '_blank')
      },
      registSucccess(){
        // 入网完成
        this.$confirm(`是否已经在汇付后台给店铺（${this.shop.name}），完成微信和支付宝支付的开通。`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then((res)=>{
          OpenMerchantSucccess({id:this.data.id}).then(res=>{
            if(res){
              this.$message.success("入网完成")
              this.refshMerchant()
            }
          })
        })
      }
    }
  };
</script>

<style lang="scss" scoped>
  .meta-top {
    color: #909399;
    font-size: 12px;
    margin-bottom: 8px;
  }

  .meta-top>span+span {
    margin-left: 20px;
  }

  .block {
    border: 1px solid var(--color-border, #ebeef5);
    border-radius: 8px;
  }

  .detail-grid {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 0;
    border: 1px solid #ebeef5;
    border-bottom: none;
  }
  ::v-deep .el-card .el-card__header {
      padding: 14px 15px 7px;
      min-height: 40px;
      background: #fafafa;
  }
</style>
